import React from 'react';

const buildCapDetailUrlFromPayUrl = (payUrl) => {
	if (!payUrl || typeof payUrl !== 'string') {
		return null;
	}

	try {
		const u = new URL(payUrl);
		const capID1 = u.searchParams.get('capID1') || u.searchParams.get('capid1');
		const capID2 = u.searchParams.get('capID2') || u.searchParams.get('capid2');
		const capID3 = u.searchParams.get('capID3') || u.searchParams.get('capid3');
		const moduleName = u.searchParams.get('Module') || u.searchParams.get('module') || 'BFP';
		const agencyCode = u.searchParams.get('agencyCode') || u.searchParams.get('agencycode') || 'FDNY';

		if (!capID1 || !capID2 || !capID3) {
			return null;
		}

		// Match the exact pattern you provided.
		const detail = new URL('https://fires.fdnycloud.org/citizenaccess/Cap/CapDetail.aspx');
		detail.searchParams.set('Module', moduleName);
		detail.searchParams.set('TabName', moduleName);
		detail.searchParams.set('capID1', capID1);
		detail.searchParams.set('capID2', capID2);
		detail.searchParams.set('capID3', capID3);
		detail.searchParams.set('agencyCode', agencyCode);
		detail.searchParams.set('IsToShowInspection', '');
		return detail.toString();
	} catch (e) {
		return null;
	}
};

const OutstandingFees = (props) => {
	const { text, rowData } = props;
	const payUrl = rowData?.outstanding_fee_pay_url;
	const capDetailUrl = buildCapDetailUrlFromPayUrl(payUrl);
	const payTarget = rowData?.id
		? `fdny-pay-${rowData.id}`
		: (rowData?.account_number ? `fdny-pay-${rowData.account_number}` : '_blank');

	const amountNumber = Number(text);
	const amountLabel = Number.isFinite(amountNumber)
		? new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(amountNumber)
		: text;

	if (!payUrl) {
		return <span>{amountLabel}</span>;
	}

	const onPayClick = (e) => {
		// If we can derive a record-specific CapDetail URL, open that first to establish
		// the Accela session in the target window, then navigate to CapFees.
		// This improves reliability vs opening CapFees directly.
		if (!capDetailUrl) {
			return;
		}

		e.preventDefault();
		const w = window.open(capDetailUrl, payTarget);
		if (!w) {
			// Popup blocked; fall back to direct navigation.
			window.location.assign(payUrl);
			return;
		}

		// Give the first page a moment to set cookies/session, then go to CapFees.
		window.setTimeout(() => {
			try {
				w.location.href = payUrl;
			} catch (err) {
				// If cross-origin access is restricted in this browser, fallback to opening CapFees.
				window.open(payUrl, payTarget);
			}
		}, 1200);
	};

	return (
		<span>
			{amountLabel}{' '}
			<a
				className="btn btn-sm btn-success data-table-pay-button"
				href={payUrl}
				target={payTarget}
				rel="noopener"
				referrerPolicy="origin"
				onClick={onPayClick}
			>
				Pay
			</a>
		</span>
	);
};

export default OutstandingFees;
